import { render, staticRenderFns } from "./HotpointVideo.vue?vue&type=template&id=44800495&scoped=true"
import script from "./HotpointVideo.vue?vue&type=script&lang=js"
export * from "./HotpointVideo.vue?vue&type=script&lang=js"
import style0 from "./HotpointVideo.vue?vue&type=style&index=0&id=44800495&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44800495",
  null
  
)

export default component.exports